import Immutable from 'immutable';

import {
  PLATFORM_ANNONCEMENTS_GET_START,
  PLATFORM_ANNONCEMENTS_GET_SUCCESS,
} from './actions';

const INITIAL_STATE = Immutable.Map({
  loading: false,
  error: false,
  posts: null,
});

export function PlatformAnnouncements(state = INITIAL_STATE, action) {
  switch (action.type) {
    case PLATFORM_ANNONCEMENTS_GET_START: {
      return state.set('loading', true);
    }
    case PLATFORM_ANNONCEMENTS_GET_SUCCESS: {
      return state.set('loading', false).set('posts', action.posts);
    }
    default: {
      return state;
    }
  }
}
